import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Image,
  message,
  Row,
  Spin,
  Tag,
  Typography,
} from "antd";
import { DeleteOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";

import { useContactsDirectory } from "../../../modules/contactsDirectory";
import {
  selectArrCitiesForContactsDirectory,
  selectContactsDirectoryForUpdate,
  selectArrCategoriesForContactsDirectory,
  setContactsDirectoryForUpdate,
  setIsContactsDirectoryForUpdate,
} from "../../../redux";
import { IDataForUpdateContactsDirectory } from "../../../redux/@types";
import {
  InputNumber,
  InputSelect,
  // InputTags,
  InputText,
  InputTextSimple,
} from "../../../shared/components/ui/inputs";
import Upload from "../../../shared/components/ui/inputs/Upload";
import { PATH_S3_BUCKET } from "../../../shared/utils/constants";
import { AdminMenuLayout } from "../../../shared/components";
import {
  WrapperCardContactsAttributes,
  WrapperCardContactsDirectory,
} from "./styled";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { WrapperTabNav } from "../../products";
import { InputHTML } from "../../../shared/components/ui/inputs/InputHTML";
import { contactsDirectoryService } from "../../../shared/services";
import { IDataAtt, useContactsAttributes } from "../hook/useContactsAttributes";

const { Title } = Typography;
export const ContactsDirectoryForUpdate = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const navigate = useNavigate();

  const getSingleDirectory = async (id: number) => {
    return await contactsDirectoryService
      .get(id)
      .then((res) => {
        return res;
      })
      .catch((err: any) => {
        console.log(err);
        navigate(`/contactsDirectory`);
        message.error(err.message);
      });
  };

  useEffect(() => {
    if (isNaN(Number(params.id))) return navigate(`/contactsDirectory`);
    getSingleDirectory(Number(params.id)).then((res) => {
      dispatch(setContactsDirectoryForUpdate(res));
      dispatch(setIsContactsDirectoryForUpdate(true));
    });
  }, []);

  const updateContactsDirectory = useSelector(selectContactsDirectoryForUpdate);
  const arrCities = useSelector(selectArrCitiesForContactsDirectory);
  const arrCategories = useSelector(selectArrCategoriesForContactsDirectory);
  const {
    isLoading,
    onSubmitCreateOrUpdate,
    updateMedia,
    isUpdateContactsDirectory,
    showDeleteConfirmOfMedia,
    arrMedia,
    usersArr,
    getArrMedia,
  } = useContactsDirectory();
  const {
    arrOfAtt,
    formAttributes,
    formAttributesForUpdate,
    iconAtt,
    textValueAtt,
    idForUpdate,
    textValueAttForUpdate,
    iconAttForUpdate,
    isLoadingAtt,
    isCreateAtt,
    isEditeAtt,
    setFormAttributes,
    setIsCreateAtt,
    setFormAttributesForUpdate,
    setIsEditeAtt,
    closeCreateCard,
    createAttributes,
    showDeleteConfirm,
    updateAttributes,
    changeUpdateAtt,
    closeUpdateAtt,
  } = useContactsAttributes();
  const {
    control,
    handleSubmit: onSubmit,
    setValue,
    getValues,
    watch,
  } = useFormContext<IDataForUpdateContactsDirectory>();

  useEffect(() => {
    getArrMedia();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const pathCover = watch("path_cover");
  return (
    <AdminMenuLayout
      pageDescription="ContactsDirectoryById"
      title="ContactsDirectoryById"
    >
      <WrapperCardContactsDirectory>
        {!isUpdateContactsDirectory ? (
          <Spin size="large" />
        ) : (
          <WrapperTabNav
            items={[
              {
                label: `DATOS DEL DIRECTORIO PROFESIONAL`,
                key: "1",
                children: (
                  <Row
                    gutter={[8, 8]}
                    style={{
                      padding: "10px",
                      width: "100%",
                    }}
                  >
                    <Col
                      span={24}
                      style={{
                        width: "100%",
                        display: "flex",
                        // padding: 5,
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        flexDirection: "row",
                      }}
                    >
                      <Title
                        style={{
                          marginBottom: "1.5px",
                          color: "var(--primary)",
                          marginRight: 7,
                        }}
                        level={2}
                      >
                        ACTUALIZANDO DIRECTORIO
                      </Title>
                      <Tag
                        style={{ fontSize: 24, padding: 8, borderRadius: 5 }}
                      >
                        ID: {updateContactsDirectory?.id!}
                      </Tag>
                    </Col>
                    <Col
                      span={8}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "1.5px" }} level={5}>
                        Nombre:
                      </Title>
                      <InputText
                        placeHolder="John Doe"
                        name="name"
                        control={control}
                      />
                    </Col>
                    <Col
                      span={8}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "1.5px" }} level={5}>
                        Ciudad:
                      </Title>
                      <InputSelect
                        showSearch
                        name="city_id"
                        control={control}
                        dataOptions={
                          arrCities?.map((item) => ({
                            value: item.id.toString(),
                            title: item.name,
                          })) || []
                        }
                        label="Ciudad"
                      />
                    </Col>
                    <Col
                      span={8}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "1.5px" }} level={5}>
                        Usuario:
                      </Title>
                      <InputSelect
                        showSearch
                        name="user_id"
                        control={control}
                        dataOptions={
                          usersArr?.map((item) => ({
                            value: item.id.toString(),
                            title: `${item.first_name} ${item.last_name}`,
                          })) || []
                        }
                        label="Usuario"
                      />
                    </Col>
                    <Col
                      span={8}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "1.5px" }} level={5}>
                        Dirección:
                      </Title>
                      <InputText
                        placeHolder="Calle 1 #2a - 3"
                        name="address"
                        control={control}
                      />
                    </Col>
                    <Col
                      span={8}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "1.5px" }} level={5}>
                        Categoría:
                      </Title>
                      <InputSelect
                        showSearch
                        name="category_id"
                        control={control}
                        dataOptions={
                          arrCategories?.map((item) => ({
                            value: item.id.toString(),
                            title: item.name,
                          })) || []
                        }
                        label="Ciudad"
                      />
                    </Col>
                    {/* {isUpdateContactsDirectory && (
                      <Col
                        span={8}
                        style={{
                          display: "flex",
                          marginTop: "10px",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          flexDirection: "column",
                        }}
                      >
                        <Title style={{ marginBottom: "1.5px" }} level={5}>
                          Atributos:
                        </Title>
                        <Col span={24}>
                          <InputTags
                            placeHolder="Agregar Atributo"
                            control={control}
                            name="attributes"
                          />
                        </Col>
                      </Col>
                    )} */}
                    <Col
                      span={8}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "1.5px" }} level={5}>
                        Imagen:
                      </Title>
                      {pathCover ? (
                        <img
                          src={`${PATH_S3_BUCKET}/${pathCover}`}
                          alt="path_cover"
                          style={{
                            marginBottom: "7px",
                            width: "100%",
                            height: "100%",
                            maxWidth: "250px",
                            maxHeight: "250px",
                          }}
                        />
                      ) : (
                        <img
                              style={{
                                marginBottom: "7px",
                                maxWidth: "250px",
                                maxHeight: "250px",
                              }}
                              alt="error"
                              src="data:image/png;base64,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"
                            />
                      )}
                      <Upload
                        filePath="path_cover"
                        onUploadedFile={(files) => {
                          // console.log({ files });
                          const file = files[0];
                          setValue("path_cover", file.fileKey);
                          message.success("Se ha actualizado la imagen");
                        }}
                      />
                    </Col>
                    {/* <Col
                      span={24}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        padding: 5,
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "1.5px" }} level={5}>
                        Calificación
                      </Title>
                      <InputNumber
                        placeHolder="3"
                        name="score"
                        control={control}
                        max={5}
                      />
                    </Col> */}
                    {/* <Col
                      span={24}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        padding: 5,
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "1.5px" }} level={5}>
                        Descripción corta:
                      </Title>
                      <InputText
                        placeHolder="Producto versátil "
                        name="short_description"
                        control={control}
                        rows
                      />
                    </Col>
                    <Col
                      span={24}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        padding: 5,
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "7.5px" }} level={5}>
                        Descripción:
                      </Title>
                      <InputHTML
                        placeHolder="Es un producto muy optimo para..."
                        name="description"
                        control={control}
                        isUpdating
                      />
                    </Col> */}
                    <Col
                      span={8}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "1.5px" }} level={5}>
                        Número de whatsApp:
                      </Title>
                      <InputNumber
                        stringMode={true}
                        placeHolder="3292321143"
                        name="whatsapp_phone"
                        control={control}
                      />
                    </Col>
                    <Col
                      span={8}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "1.5px" }} level={5}>
                        Teléfono:
                      </Title>
                      <InputNumber
                        stringMode={true}
                        placeHolder="3292321143"
                        name="phone"
                        control={control}
                      />
                    </Col>
                    <Col
                      span={8}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        padding: 5,
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "1.5px" }} level={5}>
                        Estado:
                      </Title>
                      <InputSelect
                        name="status"
                        control={control}
                        dataOptions={[
                          { title: "Activo", value: "active" },
                          { title: "Inactivo", value: "inactive" },
                        ]}
                        label="Estado"
                      />
                    </Col>
                    <Col
                      span={8}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "1.5px" }} level={5}>
                        Años de experiencia:
                      </Title>
                      <InputNumber
                        stringMode={true}
                        placeHolder="2"
                        name="years_of_experience"
                        control={control}
                      />
                    </Col>
                    <Col
                      span={8}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        padding: 5,
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Title style={{ marginBottom: "1.5px" }} level={5}>
                        Disponibilidad para trabajar:
                      </Title>
                      <InputSelect
                        name="job_availability"
                        control={control}
                        dataOptions={[
                          {
                            title: "Tiempo completo",
                            value: "tiempo_completo",
                          },
                          { title: "Medio tiempo", value: "medio_tiempo" },
                          {
                            title: "Trabajo independiente",
                            value: "trabajo_independiente",
                          },
                        ]}
                        label="Disponibilidad para trabajar"
                      />
                    </Col>
                    <Col
                      span={24}
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        padding: 5,
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <Button
                        style={{
                          marginTop: 10,
                        }}
                        type="primary"
                        shape="round"
                        size="large"
                        onClick={onSubmit(onSubmitCreateOrUpdate)}
                        loading={isLoading}
                      >
                        Actualizar información
                      </Button>
                    </Col>
                  </Row>
                ),
              },
              {
                label: `GALERÍA`,
                key: "2",
                children: (
                  <Row
                    gutter={[8, 8]}
                    style={{
                      padding: "10px",
                      width: "100%",
                    }}
                  >
                    {isUpdateContactsDirectory && (
                      <Col
                        span={24}
                        style={{
                          display: "flex",
                          marginTop: "10px",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          flexDirection: "column",
                        }}
                      >
                        {arrMedia.length !== 0 ? (
                          <Row
                            gutter={[16, 16]}
                            style={{
                              padding: "10px",
                              width: "100%",
                            }}
                          >
                            {arrMedia.map((item: any) => {
                              return (
                                <Col span={8} style={{ position: "relative" }}>
                                  <img
                                    src={`${PATH_S3_BUCKET}/${item.path}`}
                                    alt="path_media"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                    }}
                                  />
                                  <Button
                                    style={{
                                      position: "absolute",
                                      top: -10,
                                      right: 0,
                                    }}
                                    shape="circle"
                                    type="primary"
                                    danger={true}
                                    onClick={() => {
                                      showDeleteConfirmOfMedia(item.id);
                                    }}
                                    icon={<DeleteOutlined />}
                                    size="small"
                                  />
                                </Col>
                              );
                            })}
                          </Row>
                        ) : (
                            <img
                              style={{
                                marginBottom: "7px",
                                maxWidth: "250px",
                                maxHeight: "250px",
                              }}
                              alt="error"
                              src="data:image/png;base64,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"
                            />
                        )}
                        <Upload
                          filePath="path_cover"
                          onUploadedFile={(files) => {
                            const mediaArr = getValues("media");
                            const file = files[0];
                            updateMedia(
                              file.fileKey,
                              updateContactsDirectory?.id!
                            ).then((res) => {
                              getArrMedia();
                              setValue("media", [...mediaArr, res]);
                            });
                          }}
                        />
                      </Col>
                    )}
                  </Row>
                ),
              },
              {
                label: `ATRIBUTOS`,
                key: "3",
                children: (
                  <Row
                    gutter={[8, 8]}
                    style={{
                      padding: "10px",
                      width: "100%",
                    }}
                  >
                    {arrOfAtt.length === 0 ? (
                      <Col
                        span={24}
                        style={{
                          display: "flex",
                          marginTop: "1.2rem",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      >
                        <Title
                          style={{
                            marginBottom: "1.2rem",
                            textAlign: "center",
                          }}
                          level={5}
                        >
                          Todavía no se tiene atributos asociados a este
                          directorio profesional
                        </Title>
                      </Col>
                    ) : (
                      <>
                        {arrOfAtt.map((item: IDataAtt, idx) => (
                          <Col
                            xs={24}
                            sm={12}
                            md={6}
                            lg={8}
                            xl={10}
                            key={idx}
                            style={{
                              display: "flex",
                              marginTop: "1.2rem",
                              padding: 5,
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "row",
                            }}
                          >
                            {isEditeAtt && idForUpdate === item.id ? (
                              <Card>
                                <div
                                  style={{
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "center",
                                    alignSelf: "center",
                                    marginBottom: "0.9rem",
                                  }}
                                >
                                  <Button
                                    style={{
                                      position: "absolute",
                                      top: -10,
                                      right: -10,
                                    }}
                                    shape="circle"
                                    type="primary"
                                    danger={true}
                                    onClick={closeUpdateAtt}
                                    icon={
                                      <CloseOutlined
                                        style={{ fontSize: "1rem" }}
                                      />
                                    }
                                    size="middle"
                                  />
                                  {iconAttForUpdate ? (
                                    <img
                                      src={`${PATH_S3_BUCKET}/${iconAttForUpdate}`}
                                      alt="path_icon_attributes"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        maxWidth: "45px",
                                        maxHeight: "45px",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      style={{
                                        marginBottom: "7px",
                                        maxWidth: "45px",
                                        maxHeight: "45px",
                                      }}
                                      alt="error"
                                      width={"45px"}
                                      height={"45px"}
                                      src="data:image/png;base64,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"
                                    />
                                  )}
                                </div>
                                <div style={{ marginBottom: "0.9rem" }}>
                                  <Upload
                                    filePath="path_icon_attributes"
                                    onUploadedFile={(files) => {
                                      const file = files[0];
                                      console.log(file.fileKey);
                                      setFormAttributesForUpdate({
                                        ...formAttributesForUpdate,
                                        iconAttForUpdate: file.fileKey,
                                      });
                                    }}
                                  />
                                </div>
                                <InputTextSimple
                                  placeHolder="Nombre del atributo"
                                  value={textValueAttForUpdate}
                                  onChange={(e) => {
                                    setFormAttributesForUpdate({
                                      ...formAttributesForUpdate,
                                      textValueAttForUpdate: e.target.value,
                                    });
                                  }}
                                />
                                <Button
                                  type="primary"
                                  shape="default"
                                  size="large"
                                  disabled={isLoading}
                                  style={{ margin: "10px 0" }}
                                  onClick={() => updateAttributes(item.id)}
                                >
                                  Actualizar información
                                </Button>
                              </Card>
                            ) : (
                              <Card>
                                <Button
                                  style={{
                                    position: "absolute",
                                    top: -10,
                                    right: -10,
                                  }}
                                  shape="circle"
                                  type="primary"
                                  onClick={() => changeUpdateAtt(item)}
                                  icon={
                                    <EditOutlined
                                      style={{ fontSize: "1rem" }}
                                    />
                                  }
                                  size="middle"
                                />
                                <Button
                                  style={{
                                    position: "absolute",
                                    top: 25,
                                    right: -10,
                                  }}
                                  shape="circle"
                                  type="primary"
                                  danger={true}
                                  onClick={() => {
                                    showDeleteConfirm(item.id, item.name);
                                  }}
                                  icon={<DeleteOutlined />}
                                  size="middle"
                                />
                                {item.icon ? (
                                  <img
                                    src={`${PATH_S3_BUCKET}/${item.icon}`}
                                    alt="path_icon_attributes"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      maxWidth: "45px",
                                      maxHeight: "45px",
                                    }}
                                  />
                                ) : (
                                  <img
                              style={{
                                marginBottom: "7px",
                                maxWidth: "250px",
                                maxHeight: "250px",
                              }}
                              alt="error"
                              src="data:image/png;base64,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"
                            />
                                )}
                                <Title
                                  style={{
                                    marginTop: "0.5rem",
                                    textAlign: "center",
                                    fontSize: "0.9rem",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "180px",
                                  }}
                                  level={5}
                                >
                                  {item.name}
                                </Title>
                              </Card>
                            )}
                          </Col>
                        ))}
                      </>
                    )}
                    <Col
                      span={24}
                      style={{
                        display: "flex",
                        marginTop: "1.2rem",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      {isCreateAtt ? (
                        <WrapperCardContactsAttributes>
                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                              justifyContent: "center",
                              alignSelf: "center",
                              marginBottom: "0.9rem",
                            }}
                          >
                            <Button
                              style={{
                                position: "absolute",
                                top: -10,
                                right: -10,
                              }}
                              shape="circle"
                              type="primary"
                              danger={true}
                              onClick={closeCreateCard}
                              icon={
                                <CloseOutlined style={{ fontSize: "1rem" }} />
                              }
                              size="middle"
                            />
                            {iconAtt ? (
                              <img
                                src={`${PATH_S3_BUCKET}/${iconAtt}`}
                                alt="path_icon_attributes"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  maxWidth: "45px",
                                  maxHeight: "45px",
                                }}
                              />
                            ) : (
                              <img
                              style={{
                                marginBottom: "7px",
                                maxWidth: "250px",
                                maxHeight: "250px",
                              }}
                              alt="error"
                              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                            />
                            )}
                          </div>
                          <div style={{ marginBottom: "0.9rem" }}>
                            <Upload
                              filePath="path_icon_attributes"
                              onUploadedFile={(files) => {
                                const file = files[0];
                                console.log(file.fileKey);
                                setFormAttributes({
                                  ...formAttributes,
                                  iconAtt: file.fileKey,
                                });
                              }}
                            />
                          </div>
                          <InputTextSimple
                            placeHolder="Nombre del atributo"
                            value={textValueAtt}
                            onChange={(e) => {
                              setFormAttributes({
                                ...formAttributes,
                                textValueAtt: e.target.value,
                              });
                            }}
                          />
                          <Button
                            type="primary"
                            disabled={isLoading}
                            shape="default"
                            size="large"
                            style={{ margin: "10px 0" }}
                            onClick={createAttributes}
                          >
                            Guardar Atributo
                          </Button>
                        </WrapperCardContactsAttributes>
                      ) : (
                        <Button
                          type="primary"
                          shape="default"
                          size="large"
                          style={{ margin: "10px 0" }}
                          onClick={() => {
                            setIsEditeAtt(false);
                            setIsCreateAtt(true);
                          }}
                        >
                          Crear atributo
                        </Button>
                      )}
                    </Col>
                  </Row>
                ),
              },
            ]}
          />
        )}
      </WrapperCardContactsDirectory>
    </AdminMenuLayout>
  );
};
